/* @ts-self-types="./aod_sim_wasm.d.ts" */
import * as wasm from "./aod_sim_wasm_bg.wasm";
import { __wbg_set_wasm } from "./aod_sim_wasm_bg.js";

__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
export {
    RustSimAdapter, init
} from "./aod_sim_wasm_bg.js";
